import { ArrowLeft } from '@phosphor-icons/react';

export default ArrowLeft;
